export default from './DesktopNavTabs';



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/DesktopNavTabs/index.js